import { Event } from 'three';
import { engineConfig } from '@/Constants/3dConfig';
import { $ } from '@/Engine/stateInstance';
import { eventsNumLimit } from '@/Constants/common';
import { computePointerPosition } from '@/lib/computePointerPosition';
import { onPointerMoveRoomDimensions } from '@/Engine/eventHandlers/roomDimensionChanging';
import { getIntersection, getSizingBoxesIntersection } from '@/Engine/intersections';
import { onObjectMoveMode } from '@/Engine/eventHandlers/onObjectMoveMode';
import { addBoxHelpers, removeBoxHelpers } from '@/Engine/addBoxHelper';
import { useStoreData } from '@/Store/storeData';
import { useUIOnlyStore } from '@/Store/storeUI';
import { onWallIntersection } from '@/Engine/eventHandlers/onWallIntersection';
import { onNoWallIntersection } from '@/Engine/eventHandlers/onNoWallIntersection';
import { onFloorIntersection } from '@/Engine/eventHandlers/onFloorIntersection';
import { onDragAccessories } from '@/Engine/eventHandlers/onDragAccessories';
import { bracketAccessories, wallAccessories } from '@/Constants/accessories';

export const onPointerMove = (e: Event) => {
    if ($.eventsNum > eventsNumLimit) return;
    $.eventsNum += 1;
    $.createNewModule = null;
    let moved = false;
    const oldPointer = $.pointer.clone();
    $.pointer.copy(computePointerPosition($.container, e));

    if (oldPointer.distanceToSquared($.pointer) > 0.000001) {
        moved = true;
    }

    if ($.dragging && $.selection) {
        moved = true;
    }

    if (useUIOnlyStore().mode === 1) {
        onPointerMoveRoomDimensions(getSizingBoxesIntersection(), getIntersection([ $.room.ceilRaycastPlane ]));
        moved = true;
    }
    // Режим таскания и есть выделение
    if ($.dragging && $.selection) {
        if (!$.wallPointer)
            $.ctrlKey = e.ctrlKey || e.metaKey;
        onObjectMoveMode();
        moved = true;
    } else {
        $.wallPointer = null;
        $.floorPointer = null;
        $.shelfPlace = null;
    }


    if (engineConfig.boxHelper) {
        removeBoxHelpers();
        addBoxHelpers([ ...$.wardrobe.rackModules, ...$.windows, ...$.doors ]);
    }

    if ($.tempShelf) {
        moved = true;
        $.render();
        return;
    }
    // data будет если есть перемещаемый из меню объект
    let data = useStoreData().getElementDnd;

    //TODO логика с createNewModule вероятно удалена
    if ($.createNewModule)
        data = { data: useStoreData().getItemsByIdArr([ $.createNewModule ])[0] };



    if (data?.data) {
        moved = true;
        if (
            (data.category?.name?.includes('Аксессуары') || data.category?.name?.includes('Новинки')) &&
            !bracketAccessories.some(accessory => data.data.name.includes(accessory)) &&
            !wallAccessories.some(accessory => data.data.name.includes(accessory))
        ) {
            console.warn('Неподдерживаемый аксессуар');
            return;
        }

        if (data.data.name.includes('боковая')) {
            onDragAccessories(data);
            return;
        }

        // selectionBox.unselect();
        const floorIntersection = getIntersection([ $.room.floorRaycastPlane ]);
        if (floorIntersection[0] && data) {
            onFloorIntersection(floorIntersection[0], data);
            // $.render();
            // return;
        }

        const wallIntersections = getIntersection($.room.raycastPlanes);
        if (wallIntersections[0] && data) {
            onWallIntersection(wallIntersections[0], data);
            moved = true;
        } else {
            onNoWallIntersection();
            moved = true;
        }
    }

    if (moved)
        $.render();
};
